import { render, staticRenderFns } from "./limitedTimeSnapping.vue?vue&type=template&id=7235780c&scoped=true&"
import script from "./limitedTimeSnapping.vue?vue&type=script&lang=js&"
export * from "./limitedTimeSnapping.vue?vue&type=script&lang=js&"
import style0 from "./limitedTimeSnapping.vue?vue&type=style&index=0&id=7235780c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235780c",
  null
  
)

export default component.exports